<template>
    <v-container fluid>
        <v-row align="start" justify="center">
                <span>
                    <h1>Te ofrecemos los servicios pensados en tus necesidades!</h1>
                </span>
        </v-row>
        <v-row>
            <v-col cols="12" md="4" sm="12" xs="12" v-for="(servicio, i) in servicios" :key="i">
                <v-card>
                    <v-img :src="servicio.imgUrl"  :key="i"></v-img>
                    <v-card-title>
                        <span>
                            {{ servicio.titulo }}
                        </span>
                    </v-card-title>
                    <v-card-subtitle>
                        {{ servicio.contenido }}
                    </v-card-subtitle>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'App',
  created(){
    this.$vuetify.theme.dark = true
  },
  computed: {
  },
  components: {
  },

  data(){
      return {
          servicios: [
            { 
              titulo: 'Telefonía IP',
              imgUrl: require('../../public/img/telefonia_ip.png'),
              contenido: 'Tu empresa este crecimiento, la comunicación entre tus oficinas y el exterior te brindan una optimización de procesos los cuales ayudan en tus ganancias y la calidad de tu empresa. Te ayudamos a implementar la Telefonía IP en tu empresa, ofreciéndote equipos de alta gama y calidad. Pregunta nuestros paquetes. '
            },
            { 
              titulo: 'Wall Audit Start-Up',
              imgUrl: require('../../public/img/wallaudit_startup.png'),
              contenido: '¿Tienes una idea de Negocio y necesitas un sistema? Contáctenos y podemos ofrecerte la solución tecnológica a tu medida y a buen precio. '
            },
            { 
              titulo: 'Wall Audit Assist',
              imgUrl: require('../../public/img/wallaudit_assist.png'),
              contenido: 'El Seguro Médico de tus equipos. Wall Audit Assit es un programa de pago mensual o anual donde te brindamos soporte y mantenimiento asegurando todos tus equipos, computadoras, impresoras equipos de red, entre otros. Aplican restricciones.'
            },
            { 
              titulo: 'Aplicaciones Móviles',
              imgUrl: require('../../public/img/aplicaciones_moviles.png'),
              contenido: '¿Necesitas aplicación para tu negocio? Desarrollamos tu aplicación.'
            },
            { 
              titulo: 'Diseño de Publicidad',
              imgUrl: require('../../public/img/disenio_publicidad.png'),
              contenido: '¿La presentación de tu empresa es uno de los puntos más importantes para darse a conocer, te ayudamos a crear todo tipo de diseños, como: Diseño de Logos y Logotipos. Edición y creación de Fotografía. Edición y creación de vídeos y audio.'
            },
            { 
              titulo: 'Soporte y Asesorias',
              imgUrl: require('../../public/img/soporte_asesorias.png'),
              contenido: '¿Dudas sobre tus equipos? ¿Quieres comprar un nuevo equipo, pero no sabes que necesitas? Te orientamos en todas tus preguntas sobre tus equipos.'
            },
            { 
              titulo: 'Mantenimiento de Equipos',
              imgUrl: require('../../public/img/mantenimiento_equipos.png'),
              contenido: '¿Sabías que el mantenimiento preventivo ayuda a reducir daños en tu equipo? No esperes a que tu equipo tenga fallas, pregunta por nuestros paquetes, nos adaptamos a tus necesidades.'
            },
            { 
             titulo: 'Desarrollo Web',
             imgUrl: require('../../public/img/desarrollo_web.png'),
             contenido: 'Si tu negocio no tiene presencia en internet, no existe!!!'
            }
      ]
    }
    }
};
</script>

<style>

</style>